module.exports = __webpack_public_path__ + "img/kino_kunsthalle_1_a.cc20dd81.jpg";